/* eslint-disable @typescript-eslint/no-unused-vars */

import { initializeApp } from "firebase/app";
import {
  getMessaging,
  getToken,
  onMessage,
  isSupported,
} from "firebase/messaging";
import { getRemoteConfig } from "firebase/remote-config";

import { ETokenType } from "../enums";
import { updateUserToken } from "../setup/api/services/user";
import { AuthConfig } from "../setup/context/config/authConfig";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

export type RemoteConfig = {
  _source: string;
  _value: string;
};

const app = initializeApp(firebaseConfig);

export const remoteConfig = getRemoteConfig(app);

export const requestFireBaseToken = async (): Promise<string | void> => {
  const messagingSupported = await isSupported();
  console.log("messagingSupported", messagingSupported);
  if (!messagingSupported) {
    return;
  }
  return new Promise((resolve, reject) => {
    console.log("do we reach here");
    let messaging;
    try {
      messaging = getMessaging();
    } catch (error) {
      console.error("firebase error", error);
      reject;
    }
    getToken(messaging, {
      vapidKey: process.env.REACT_APP_FIREBASE_VAPI_KEY,
    })
      .then(async (currentToken) => {
        if (currentToken) {
          console.log("current token for client: ", currentToken);
          resolve(currentToken);
          const userId = AuthConfig.getUserInfo().id;
          await updateUserToken(userId, {
            token: currentToken,
            tokenType: ETokenType.FCM,
          });
        } else {
          reject(
            "No registration token available. Request permission to generate one."
          );
        }
      })
      .catch((err) => {
        reject("An error occurred while retrieving token. " + err);
      });
  });
};
export const onMessageListener = async () => {
  const messagingSupported = await isSupported();
  if (!messagingSupported) {
    return;
  }
  new Promise((resolve, reject) => {
    const messagingSupported = isSupported();
    if (!messagingSupported) {
      reject;
    }
    let messaging;
    try {
      messaging = getMessaging();
    } catch (error) {
      console.error("firebase error", error);
      reject;
    }
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });
};

export const registerServiceWorker = () => {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker
      .register("../firebase-messaging-sw.js")
      .then(function (registration) {
        console.log("Registration successful, scope is:", registration.scope);
      })
      .catch(function (err) {
        console.log("Service worker registration failed, error:", err);
      });
  }
};
